import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/agent_attorney_actions";
import ReactTooltip from "react-tooltip";
import cellGenerator from "./columnUtils";

const agent_attorney_columns = (isSubaccount) => [
  {
    Header: "Profile Name",
    accessor: "AgentProfileFormData.new_profile_atty_agent_profile_name",
    Cell: ({ row: { original } }) => {
      const formData = original.AgentProfileFormData;
      let profileName = formData.new_profile_atty_agent_profile_name;
      let legalBusinessName = formData.new_profile_atty_agent_dba;
      let fein = formData.new_profile_atty_agent_fein;
      return (
        <Fragment>
          <span
            title={profileName}
            data-tip
            data-for={profileName}
            className="cell"
          >
            <Link
              className={"usa-link"}
              to={{
                pathname: `/dashboard/profiles/agent-attorney/individuals/${profileName.replace(
                  //eslint-disable-next-line
                  /[\\|\/\s]/g,
                  ""
                  //eslint-disable-next-line
                )}/${legalBusinessName.replace(/[\\|\/\s]/g, "")}/${fein}/${
                  original.id
                }`,
              }}
            >
              {profileName}
            </Link>
          </span>
          <ReactTooltip id={profileName} type="dark" effect="solid">
            <span>{profileName}</span>
          </ReactTooltip>
        </Fragment>
      );
    },
  },
  {
    Header: "Legal Business Name",
    accessor: "AgentProfileFormData.new_profile_atty_agent_dba",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "FEIN",
    accessor: "AgentProfileFormData.new_profile_atty_agent_fein",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Number of Profiles",
    accessor: "numberOfAgents",
    Cell: (props) => <span className="cell">{props.value}</span>,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("agent-attorney", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default agent_attorney_columns;
